module.exports = __webpack_public_path__ + "static/media/CheckCircle.213b2f9c.svg";